import Box from 'shared_DEPRECATED/components/Box';
import { FileDownloadButton } from 'shared_DEPRECATED/components/File';
import { UploadedFile } from 'shared_DEPRECATED/components/File/UploadedFile';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { SessionRecapAttachmentType } from 'features/sessions/config/types';

import { ButtonIcon } from 'shared/components/Button';

import { SessionRecapUnUploadedAttachments } from './UnUploadedAttachments';

type SessionsRecapAttachmentsProps = {
  attachments: SessionRecapAttachmentType[];
  onDelete?: (index: number) => void;
  onUploadSuccess?: (uploadedAttachments: SessionRecapAttachmentType[]) => void;
  onUploadError?: () => void;
};

export const SessionsRecapAttachments = ({
  attachments,
  onDelete,
  onUploadSuccess,
  onUploadError,
}: SessionsRecapAttachmentsProps) => {
  const unUploadedAttachments = attachments.filter(
    (attachment) => !attachment.attachmentId
  );
  const uploadedAttachments = attachments.filter(
    (attachment) => attachment.attachmentId
  );

  return (
    <>
      <Spacer size="md zr lg" />
      <Box
        style={{
          width: ' 100%',
          display: 'grid',
          gridTemplateColumns: `repeat(2, 1fr)`,
          gap: 'var(--spacing04)',
        }}
      >
        {uploadedAttachments.map(
          ({ attachmentId, url, name, contentType }, index) => (
            <UploadedFile
              key={attachmentId}
              name={name}
              contentType={contentType}
            >
              {url && <FileDownloadButton url={url} name={name} />}
              {!!onDelete && (
                <ButtonIcon
                  aria-label="remove file"
                  onClick={() => onDelete(index)}
                  variant="ghost"
                >
                  <Icon name={iconNames.cross} />
                </ButtonIcon>
              )}
            </UploadedFile>
          )
        )}
        <SessionRecapUnUploadedAttachments
          attachments={unUploadedAttachments}
          onSuccess={onUploadSuccess}
          onError={onUploadError}
        />
      </Box>
    </>
  );
};
